export default () => ({
  agreements: null,
  error: '',
});
